export default __webpack_public_path__ + "static/broderie2.mobile.inspirations-e15ad7780cb00a1300b023dca188b665.jpg";